import { EffectsModule } from '@ngrx/effects';
import { PatientsEffects } from './client.effect';

export const RxManagerEffectsModules = EffectsModule.forFeature([PatientsEffects]);
